import ajax from '@/utils/ajax'
export default {
  // 获取智能感知数据
  getIntellisenseData(params) {
    return ajax({
      url: 'gt6/businessCompanySearch/getIntellisenseData',
      method: 'GET',
      params
    })
  },
  // 获取行业类型数据
  getIndustryCategoryOptions(params) {
    return ajax({
      url: 'gt6/businessCompanySearch/getIndustryCategoryOptions',
      method: 'GET',
      params
    })
  },
  //企业贸易情报计算数据
  getCompanyStat(params){
    return ajax({
      url: 'gt6/businessCompanyDetail/getCompanyStat',
      method: 'GET',
      params
    })
  },
   //获取商业数据查询总数
   getRelationCompany(params){
    return ajax({
      url: 'gt6/businessCompanyDetail/getRelationCompany',
      method: 'GET',
      params
    })
  },
  //商业数据详情下载
  getDownloadData(params){
    return ajax({
      url: 'gt6/businessCompanyDetail/getDownloadData',
      method: 'GET',
      params
    })
  },
   //商业数据关注接口
   getCollectBusinessCompany(data){
    return ajax({
      url: 'gt6/businessCompanySearch/collectBusinessCompany',
      method: 'POST',
      data
    })
  },
  // 获取行业编码描述 /api/gt/businessCompanySearch/getCodeDesc
  getCodeDesc(data){
    return ajax({
      url: 'gt6/businessCompanySearch/getCodeDesc',
      method: 'POST',
      data
    })
  },
  //获取商业数据交易量
  getTradeCountData(data){
    return ajax({
      url: 'gt6/businessCompanySearch/getTradeCountData',
      method: 'POST',
      data
    })
  },
  //获取商业指标数据
  getIndexData(params){
    return ajax({
      url: 'gt6/businessCompanySearch/getIndexData',
      method: 'GET',
      params
    })
  },
  //获取商业指标数据
  getIndustryCategoryCode(params){
    return ajax({
      url: 'gt6/businessCompanySearch/getIndustryCategoryCode',
      method: 'GET',
      params
    })
  },
}